import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">Я очень люблю людей. 
      </p>
      
      <p class="mb-3">
        Не знаю, откуда у меня эта любовь; наверное, я с ней родилась. 
        Когда я вижу этих огромных, розовых, вытянутых вверх, с волосами наверху, меня охватывает такая нежность! 
        Они вовсе не кажутся мне уродами, наоборот, мне представляется, что красивее их нет никого на свете.
      </p>
      
      <p class="mb-5">
        Если уж я не могу быть, как они, мне хотелось бы сделать что-нибудь хорошее для них, как-нибудь показать, выразить свою любовь…
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>

      
      <p class="mb-3">
        - Вы заметили, как ведёт себя эта свинка № 35-б-07? 
        Она всё время попадается мне под руки в общем загоне, даже когда я прохожу без корма.
      </p>
      
      <p class="mb-5">
        - Ну что же, возьмите её в следующий опыт. 
        Легче отлавливать, легче следить…
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>

      
      <p class="mb-3">
        Ура, меня заметили!!! 
        ОН сам взял меня на руки, куда-то отнёс… меня посадили в отдельную клетку, но мне не скучно. 
        Ведь здесь вокруг меня всё время ЛЮДИ, я могу их видеть, слышать…
      </p>
      
      <p class="mb-3">
        Их язык я теперь понимаю больше; и я вижу, что и они захотели понять меня. 
        Первый шаг сделан: они обратили на меня внимание, приблизили к себе. 
      </p>
      
      <p class="mb-5">
        Теперь нужно только объяснить им то, что я хочу сказать – и барьер непонимания между видами будет уничтожен. 
        Люди научатся понимать язык животных, как я научилась понимать язык людей. 
        Только не бросайте меня, займитесь мной, постарайтесь меня понять! 
        Ведь не словами и языком я буду говорить; люди откроют для себя новый мир, огромный, весь мир природы, 
        и всё живое наконец-то объединится в едином сознании, и станет могучей силой. 
        Не будет каждый вид сражаться в одиночку за своё выживание на Земле; вместе, только вместе мы сможем выжить и сохранить Жизнь!
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>

      
      <p class="mb-3">
        - Да, так ты взял ту свинку в опыт?
      </p>
      
      <p class="mb-5">
        - Давно. Такая смешная: я проверял на ней суммированный эффект жёсткого облучения и гепатита; так она до самой смерти лизала мне руки. 
        До чего глупы животные! 
        Таких и не жалко резать для науки. 
        Зато на ней я получил пару хороших данных для дисера. 
        Послужила людям, тескзать.
      </p>
      
      
      <p class="text-center bold mb-3">* * *</p>

      
      <p class="mb-3">
        Но когда жёсткое излучение в самом деле охватило всю Землю, не спаслись ни люди, ни свиньи. 
        Всё живое, каждое в своей скорлупе, погибло поодиночке.
      </p>
      
      <p class="mb-3">
        Разрушились горы, высохли моря. 
        Рубикон был перейдён; критический момент, когда Всё Живое могло объединиться, остался далеко позади. 
      </p>
    

    </div>
    `
  )
}

const itemName = {
  rus: `Нечто о любви`
}

const itemDate = {
  rus: `15 ноября 2011, Наука и жизнь, 4-2011, статья о специально выведенных подопытных свинках`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;


